//Install
import React, { Component } from "react";
//Install
import { Container, Row, Col } from "react-bootstrap";
//Install
import Header from "../../../../World/Az/Header";
//Install
import Footer from "../../../../World/Az/Footer";
//Install
import M597I5 from "../../../../../Media/Image/053.jpg";

//Element
class Default extends Component {
    //Element
    componentDidMount() {
        //Element
        document.title = "İşıqlandırma : Temas Elektrik Müqaviləsi"
        //Element
        document.getElementsByTagName("meta")["description"].content = "Temas Elektrik, Davamlı və Etibarlı Enerji Xidmətləri ilə Hər Toxunuş Gələcəyə Dəyər Qatar."
        //Element
        let URL = "https://temaselektrik.com/az/isiqlandirma"
        //Element
        let Canonical = document.querySelector("link[rel='canonical']")
        //Element
        Canonical.setAttribute("href", URL);
    }
    //Element
    render() {
        //Element
        const Content = React.createElement("div", { className: "website-application" },
            //Element
            React.createElement(Header, {}),
            //Element
            React.createElement("main", { className: "S6pt64 C96Q4r pEO064 a527eB d3c437" },
                //Element
                React.createElement("section", { className: "S6pt64 C96Q4r pEO064 a527eB f1d74t" },
                    //Element
                    React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB p33e0e" },
                        //Element
                        React.createElement("figure", { className: "S6pt64 C96Q4r pEO064 a527eB i457do" })
                    )
                ),
                //Element
                React.createElement("section", { className: "S6pt64 C96Q4r pEO064 a527eB gq620v" },
                    //Element
                    React.createElement(Container, {},
                        //Element
                        React.createElement(Row, {},
                            //Element
                            React.createElement(Col, { md: 12 },
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB v431h7" },
                                    //Element
                                    React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB yk8549" },
                                        //Element
                                        React.createElement("h1", { className: "S6pt64 C96Q4r pEO064 a527eB u7760y" },
                                            //Element
                                            "İşıqlandırma"
                                        )
                                    )
                                )
                            ),
                            //Element
                            React.createElement(Col, { md: 6 },
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB q95k0u" },
                                    //Element
                                    React.createElement("h2", { className: "S6pt64 C96Q4r pEO064 a527eB q887o2" },
                                        //Element
                                        "İşıqlan",
                                        //Element
                                        React.createElement("strong", {},
                                            //Element
                                            "dırma "
                                        ),
                                        //Element
                                        "Xidmətləri"
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "Temas Elektrik İşıqlandırma; Hər Layihədə Tələb Olunan Material Dəstəyini Fasiləsiz Təmin Edərək İşlərin Təhlükəsiz İrəliləməsinə Töhfə Verir. Bu Sahədə Təqdim Olunan Davamlı Və Etibarlı Xidmət İşlərimizin Əsasını Təşkil Edir.",
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "Elektrik materiallarından avtomasiya avadanlıqlarına, işıqlandırma məhsullarından kabel və şalt materiallarına qədər lazım olan bütün məhsulları keyfiyyət prinsiplərinə uyğun şəkildə müştərilərimizə çatdırırıq."
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "Elektromarket xidmətləri; fərdi istifadəçilərin və korporativ layihələrin tələblərini qarşılamaq üçün hazırlanmışdır. Geniş stok üstünlüyü, sürətli təchizat prosesləri və etibarlı markalarla əməkdaşlıq sayəsində hər ölçüdə layihəyə düzgün məhsulu çatdırırıq."
                                    )
                                )
                            ),
                            //Element
                            React.createElement(Col, { md: 6 },
                                //Element
                                React.createElement("picture", { className: "S6pt64 C96Q4r pEO064 a527eB e649gp" },
                                    //Element
                                    React.createElement("img", { alt: "İşıqlandırma", title: "İşıqlandırma", src: M597I5, width: "636", height: "auto" })
                                )
                            )
                        )
                    )
                )
            ),
            //Element
            React.createElement(Footer, {})
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default Default;